<template>
    <div>
        <v-row align="baseline">
            <v-col>작성일</v-col>
            <v-col><v-text-field v-model="value.writeDate" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>문서번호</v-col>
            <v-col><v-text-field v-model="value.documentNo" hide-details dense/></v-col>
        </v-row>
        <v-divider />
        <v-row align="baseline">
            <v-col>공급받는자 구분</v-col>
            <v-col><v-select v-model="value.invoiceeType" :items="invoiceeTypes" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>공급받는자 사업자번호</v-col>
            <v-col><v-text-field v-model="value.invoiceeCorpNum" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>공급받는자 상호</v-col>
            <v-col><v-text-field v-model="value.invoiceeCorpName" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>공급받는자 대표자성명</v-col>
            <v-col><v-text-field v-model="value.invoiceeCEOName" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>공급받는자 이메일</v-col>
            <v-col><v-text-field v-model="value.invoiceeEmail1" hide-details dense/></v-col>
        </v-row>
        <v-divider />
        <v-row align="baseline">
            <v-col>구매일</v-col>
            <v-col><v-text-field v-model="value.purchaseDT" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>항목명</v-col>
            <v-col><v-text-field v-model="value.itemName" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>공급가액</v-col>
            <v-col><v-text-field v-model="value.supplyCost" hide-details dense/></v-col>
        </v-row>
        <v-row align="baseline">
            <v-col>세액</v-col>
            <v-col><v-text-field v-model="value.tax" hide-details dense/></v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            writeDate: { type: String, default: "" },
            documentNo: { type: String, default: "" },
            invoiceeType: { type: String, default: "" },
            invoiceeCorpNum: { type: String, default: "" },
            invoiceeCorpName: { type: String, default: "" },
            invoiceeCEOName: { type: String, default: "" },
            invoiceeEmail1: { type: String, default: "" },
            supplyCostTotal: { type: String, default: "" },
            taxTotal: { type: String, default: "" },
            totalAmount: { type: String, default: "" },
            purchaseDT: { type: String, default: "" },
            itemName: { type: String, default: "" },
            supplyCost: { type: String, default: "" },
            tax: { type: String, default: "" },
        },
    },
    data() {
        return {
            invoiceeTypes: ["사업자", "개인", "외국인"],
        };
    },
    watch: {
        "value.supplyCost"() {
            this.value.supplyCostTotal = this.value.supplyCost;
            this.value.totalAmount = (+this.value.supplyCost + +this.value.tax).toString();
            this.$emit("input", this.value);
        },
        "value.tax"() {
            this.value.taxTotal = this.value.tax;
            this.value.totalAmount = (+this.value.supplyCost + +this.value.tax).toString();
            this.$emit("input", this.value);
        },
    },
};
</script>

<style></style>
